import { useState } from "react";
import { useParams, Link } from "react-router-dom";
import API_BASE_URL from '../config';
import '../styles/auth.css';

export default function ResetPassword() {
  const { token } = useParams();
  // const navigate = useNavigate();
  
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);

  const apiRoot = API_BASE_URL.replace(/\/api\/?$/, '');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setMessage("");

    if (!password || !confirmPassword) {
      setError("Ju lutem plotësoni të gjitha fushat.");
      return;
    }
    if (password !== confirmPassword) {
      setError("Fjalëkalimet nuk përputhen.");
      return;
    }

    setIsLoading(true);

    try {
      const res = await fetch(`${apiRoot}/api/auth/reset-password`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ token, password })
      });
      const data = await res.json().catch(() => ({}));

      if (res.ok) {
        setIsSuccess(true);
        setMessage(data.message || "Fjalëkalimi u ndryshua me sukses.");
      } else {
        setError(data.message || "Ndodhi një gabim gjatë ndryshimit të fjalëkalimit.");
      }
    } catch (err) {
      setError("Ndodhi një gabim me lidhjen.");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="auth-page">
      <div className="auth-card">
        <div className="auth-icon-badge">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M21 2l-2 2m-1.5 1.5L16 7m-1.5 1.5L13 10m-1.5 1.5L10 13l-4 4-4-4 4-4 7-7 7 7-2 2z" />
            <circle cx="7.5" cy="7.5" r=".5" fill="currentColor" />
          </svg>
        </div>
        <h2 className="auth-title">Ndrysho Fjalëkalimin</h2>
        
        {isSuccess ? (
          <div>
            <div className="auth-message" style={{ margin: '18px 0' }}>{message}</div>
            <Link to="/login" style={{ textDecoration: 'none' }}>
              <button type="button" className="auth-submit" style={{ width: '100%' }}>
                Shko te Kyçja
              </button>
            </Link>
          </div>
        ) : (
          <form onSubmit={handleSubmit} className="auth-form">
            <p className="auth-sub">Shkruani fjalëkalimin tuaj të ri më poshtë.</p>
            
            <div className="password-row">
              <input 
                className="auth-input" 
                placeholder="Fjalëkalimi i ri" 
                type={showPassword ? 'text' : 'password'} 
                value={password} 
                onChange={(e) => setPassword(e.target.value)} 
              />
              <button type="button" className="eye-btn" onClick={() => setShowPassword(s => !s)} aria-label="Toggle password">
                {showPassword ? (
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24" />
                    <line x1="1" y1="1" x2="23" y2="23" />
                  </svg>
                ) : (
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
                    <circle cx="12" cy="12" r="3" />
                  </svg>
                )}
              </button>
            </div>

            <div className="password-row">
              <input 
                className="auth-input" 
                placeholder="Konfirmo fjalëkalimin e ri" 
                type={showPassword ? 'text' : 'password'} 
                value={confirmPassword} 
                onChange={(e) => setConfirmPassword(e.target.value)} 
              />
            </div>
            
            <button type="submit" className="auth-submit" disabled={isLoading}>
              {isLoading ? "Duke ruajtur..." : "Ruaj Fjalëkalimin"}
            </button>

            {error && <p className="auth-error" style={{marginTop: '10px'}}>{error}</p>}
          </form>
        )}
      </div>
    </div>
  );
}
